import React, { useState } from 'react';
import {
  Box,
  Button,
  Divider,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { CreditImage } from './home-page/credit-image';
import { TbBrandLinkedin } from 'react-icons/tb';
import { TbMail } from 'react-icons/tb';
import { sendRequest } from '../../../services/global/global.service';
import { urlConfig } from '../../../config/urlConfig';
import validator from 'validator';
import './style.css';
import { useContext } from 'react';
import { GlobalContext } from '../../../services/global/GlobalState';

const useStyle = makeStyles((theme) => {
  return {
    link: {
      fontSize: 12,
      color: theme.text.primary,
    },
    container: {
      textAlign: 'center',
      maxWidth: 1032,
      margin: '0 auto',
      height: '70%',
      [theme.breakpoints.down('md')]: {
        padding: '24px 32px 24px 32px',
      },
    },
    footer: {
      backgroundColor: '#eaeaea',
      textAlign: 'center',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        paddingBottom: 1,
      },
      [theme.breakpoints.up('md')]: {
        height: 185,
      },
    },
    contactBox: {
      textAlign: 'start',
      [theme.breakpoints.down('md')]: {
        marginTop: 24,
      },
    },
    mail: {
      [theme.breakpoints.down('md')]: {
        fontSize: 20,
      },
      fontSize: 24,
      marginRight: 8,
    },
    linkedin: {
      [theme.breakpoints.down('md')]: {
        fontSize: 22,
        marginLeft: '-1px',
      },
      fontSize: 26,
      marginRight: 8,
    },
    submitBtn: {
      marginLeft: '-24px',
      height: 36,
      borderRadius: 8,
      fontWeight: 500,
      fontSize: 16,
      [theme.breakpoints.down('xs')]: {
        fontWeight: 600,
        fontSize: 18,
        marginLeft: 0,
        width: '100%',
      },
    },
    addEmailTitle: {
      marginBottom: 16,
      textAlign: 'start',
      fontWeight: 600,
      [theme.breakpoints.down('md')]: {
        fontWeight: 500,
        fontSize: 16,
      },
    },
    divider: {
      margin: '0px auto',
    },
    copyRightText: {
      fontSize: 12,
    },
    copyRightBox: {
      marginTop: 16,
      [theme.breakpoints.down('md')]: {
        marginTop: 24,
        marginBottom: 24,
      },
    },
    subscribe: {
      alignItems: 'start',
      display: 'flex',
      maxWidth: 300,
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    textField: {
      width: '100%',
      [theme.breakpoints.only('sm')]: {
        width: '50%',
      },
      [theme.breakpoints.down('xs')]: {
        marginBottom: 16,
      },
    },
    dividerBox: {
      maxWidth: 1032,
      margin: '0 auto',
      [theme.breakpoints.down('sm')]: {
        padding: '0 32px',
      },
    },
  };
});

const Footer = () => {
  const classes = useStyle();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);
  const { setOpenSubscribeAlert, setSubscribeError } =
    useContext(GlobalContext);

  const sendEmails = () => {
    if (email && validator.isEmail(email)) {
      sendRequest(urlConfig.subscribe, null, 'post', {
        email,
      })
        .then((res) => {
          setOpenSubscribeAlert(true);
        })
        .catch(
          (e) =>
            e.response &&
            e.response.data &&
            e.response.data.email &&
            setSubscribeError(true)
        );
    } else {
      setError(true);
    }
  };

  return (
    <Box className={classes.footer}>
      <Grid
        container
        className={classes.container}
        spacing={0}
        justifyContent='space-between'
      >
        <Grid item xs={12} md={4}>
          <Box
            display='flex'
            justifyContent='center'
            flexDirection='column'
            height='100%'
          >
            <Typography className={classes.addEmailTitle}>
              Be the first to receive updates on Mizban.
            </Typography>
            <Box className={classes.subscribe}>
              <input
                type='email'
                title=''
                style={{
                  border: error ? '1px #D32F2F solid' : '1px #FAFAFA solid',
                }}
                placeholder='Enter your email address'
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError(false);
                }}
                id='subscribe'
              />
              <Button
                color='primary'
                variant='contained'
                disableElevation
                className={classes.submitBtn}
                onClick={sendEmails}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={4} className={classes.contactBox}>
          <Box
            display='flex'
            justifyContent='center'
            flexDirection='column'
            height='100%'
          >
            <Typography style={{ fontWeight: 500 }}>Contact us</Typography>
            <Box display='flex' alignItems='center' mt={1}>
              <TbMail className={classes.mail} />
              <Link className={classes.link}>Admin@mizbans.com</Link>
            </Box>
            <Box display='flex' alignItems='center'>
              <TbBrandLinkedin fontSize={16} className={classes.linkedin} />
              <a
                target='_blank'
                href='https://www.linkedin.com/company/mizbans/'
                className={classes.link}
                rel='noreferrer'
              >
                Linkedin
              </a>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box className={classes.dividerBox}>
        <Grid className={classes.divider} xs={12}>
          <Divider />
        </Grid>
      </Box>

      <Box className={classes.copyRightBox}>
        <Typography className={classes.copyRightText}>
          Copyright @ 2022 Mizban
        </Typography>

        <CreditImage open={open} setOpen={setOpen} />
      </Box>
    </Box>
  );
};

export default Footer;
